// Uint8Array <-> base64 helpers for wire format.
// Wire format treats ciphertext / nonce / wrapped DEK as base64 strings.
// The server stores these strings verbatim (InMemoryRepo / Phase 3 Postgres
// will store as bytea). Client decodes when decrypting on lookup.

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]!);
  }
  return btoa(binary);
}

export function base64ToBytes(b64: string): Uint8Array {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}
